import React, { useEffect, useState } from 'react';
import AdminLayout from './AdminLayout';
import RateSheetModal from '../../components/RateSheetModal';

const API_BASE = process.env.REACT_APP_API_BASE || 'https://app.titanelectricreno.com:8080/api';
function getToken() { try { return JSON.parse(localStorage.getItem('titan_session') || 'null')?.token; } catch { return null; } }
function apiFetch(path, opts = {}) {
  return fetch(`${API_BASE}${path}`, { ...opts, headers: { 'Content-Type': 'application/json', 'x-worker-token': getToken(), ...opts.headers } })
    .then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));
}
const CATS = ['Labor', 'Truck', 'Equipment'];

export default function AdminRateSheet() {
  const [items, setItems] = useState(null);
  const [showPdf, setShowPdf] = useState(false);
  const [addCat, setAddCat] = useState(null);
  const [draft, setDraft] = useState({ description: '', rate: '' });

  function load() { apiFetch('/rate-sheet').then(d => setItems(Array.isArray(d.items) ? d.items : [])).catch(() => setItems([])); }
  useEffect(() => { load(); }, []);

  async function saveField(it, field, value) {
    if (String(value) === String(it[field] ?? '')) return;
    try { const upd = await apiFetch(`/rate-sheet/items/${it.id}`, { method: 'PATCH', body: JSON.stringify({ [field]: value }) });
      setItems(list => list.map(x => x.id === it.id ? upd : x)); } catch {}
  }
  async function addItem(category) {
    if (!draft.description.trim()) { setAddCat(null); return; }
    try { const it = await apiFetch('/rate-sheet/items', { method: 'POST', body: JSON.stringify({ category, description: draft.description.trim(), rate: draft.rate }) });
      setItems(list => [...list, it]); setDraft({ description: '', rate: '' }); setAddCat(null); } catch {}
  }
  async function del(it) {
    if (!window.confirm(`Remove "${it.description}" from the rate sheet?`)) return;
    try { await apiFetch(`/rate-sheet/items/${it.id}`, { method: 'DELETE' }); setItems(list => list.filter(x => x.id !== it.id)); } catch {}
  }

  const cats = items ? [...new Set([...CATS, ...items.map(i => i.category)])] : CATS;
  const inp = { border: '1px solid #e5e7eb', borderRadius: 6, padding: '7px 9px', fontSize: 14, boxSizing: 'border-box' };

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <div>
          <h1 className="admin-page-title">Rate Sheet</h1>
          <p className="admin-page-sub">Your Labor, Truck &amp; Equipment billing rates — edit here, then hand a branded copy to a customer</p>
        </div>
        <button onClick={() => setShowPdf(true)} style={{ padding: '10px 18px', borderRadius: 8, border: 'none', background: 'var(--orange, #e87722)', color: '#fff', fontWeight: 700, fontSize: 14, cursor: 'pointer' }}>📄 Customer PDF</button>
      </div>

      {items === null ? (
        <div className="admin-empty">Loading…</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 18, maxWidth: 640 }}>
          {cats.map(cat => {
            const rows = items.filter(i => i.category === cat);
            return (
              <div key={cat} className="admin-card" style={{ padding: 16 }}>
                <div style={{ fontSize: 13, fontWeight: 800, color: '#7c3aed', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 10 }}>{cat}</div>
                {rows.length === 0 && addCat !== cat && <div style={{ fontSize: 13, color: '#9ca3af', marginBottom: 8 }}>No {cat.toLowerCase()} rates yet.</div>}
                {rows.map(it => (
                  <div key={it.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0', borderTop: '1px solid #f3f4f6' }}>
                    <input defaultValue={it.description} onBlur={e => saveField(it, 'description', e.target.value)} style={{ ...inp, flex: 1 }} />
                    <span style={{ color: '#6b7280' }}>$</span>
                    <input defaultValue={it.rate} onBlur={e => saveField(it, 'rate', e.target.value)} inputMode="decimal" style={{ ...inp, width: 80, textAlign: 'right' }} />
                    <span style={{ fontSize: 12, color: '#9ca3af', width: 26 }}>/{(it.unit || 'HR').toLowerCase()}</span>
                    <button onClick={() => del(it)} title="Remove" style={{ background: 'none', border: 'none', color: '#d1d5db', fontSize: 18, cursor: 'pointer' }}>×</button>
                  </div>
                ))}
                {addCat === cat ? (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 0', borderTop: '1px solid #f3f4f6' }}>
                    <input autoFocus placeholder="Item name" value={draft.description} onChange={e => setDraft(d => ({ ...d, description: e.target.value }))} style={{ ...inp, flex: 1 }} />
                    <span style={{ color: '#6b7280' }}>$</span>
                    <input placeholder="0" value={draft.rate} onChange={e => setDraft(d => ({ ...d, rate: e.target.value }))} inputMode="decimal" style={{ ...inp, width: 80, textAlign: 'right' }} />
                    <button onClick={() => addItem(cat)} style={{ padding: '7px 12px', borderRadius: 7, border: 'none', background: '#16a34a', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>Add</button>
                    <button onClick={() => { setAddCat(null); setDraft({ description: '', rate: '' }); }} style={{ background: 'none', border: 'none', color: '#9ca3af', fontSize: 13, cursor: 'pointer' }}>Cancel</button>
                  </div>
                ) : (
                  <button onClick={() => { setAddCat(cat); setDraft({ description: '', rate: '' }); }} style={{ marginTop: 8, padding: '6px 12px', borderRadius: 7, border: '1px dashed #cbd5e1', background: '#f8fafc', color: '#374151', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>+ Add {cat} rate</button>
                )}
              </div>
            );
          })}
        </div>
      )}

      {showPdf && <RateSheetModal initial={null} onClose={() => setShowPdf(false)} />}
    </AdminLayout>
  );
}
